const IconWater = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.5 8 4 12.5 4 15.5a8 8 0 0016 0C20 12.5 17.5 8 12 2z"/>
  </svg>
);

const IconFlame = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2c0 6-6 8-6 14a6 6 0 0012 0c0-3-2-5-3-7-1 2-1 3.5-3 5 0-4 2-7 0-12z"/>
  </svg>
);

const IconSnowflake = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="2" x2="12" y2="22"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
    <line x1="19.07" y1="4.93" x2="4.93" y2="19.07"/>
    <polyline points="12 6 12 2 8 4"/>
    <polyline points="12 6 12 2 16 4"/>
    <polyline points="12 18 12 22 8 20"/>
    <polyline points="12 18 12 22 16 20"/>
  </svg>
);

const IconBathroom = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12h16v4a4 4 0 01-4 4H8a4 4 0 01-4-4v-4z"/>
    <path d="M4 12V6a2 2 0 012-2h1a2 2 0 012 2v1"/>
    <line x1="4" y1="20" x2="4" y2="22"/>
    <line x1="20" y1="20" x2="20" y2="22"/>
  </svg>
);

const IconHeatPump = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
  </svg>
);

const SERVICES = [
  {
    icon: <IconWater />,
    title: 'Plomberie',
    desc: 'Installation, rénovation et dépannage de réseaux d\'eau potable et d\'évacuation. Intervention rapide sur tous types de fuites, réparation de canalisations et installation sanitaire.',
    featured: false,
  },
  {
    icon: <IconFlame />,
    title: 'Chauffage',
    desc: 'Installation et entretien de systèmes de chauffage central, chaudières gaz et fioul, radiateurs et planchers chauffants pour un confort optimal en toute saison.',
    featured: false,
  },
  {
    icon: <IconSnowflake />,
    title: 'Climatisation',
    desc: 'Pose et maintenance de climatiseurs gainables, splits et systèmes réversibles. Profitez d\'un air frais l\'été et d\'un chauffage d\'appoint efficace l\'hiver.',
    featured: false,
  },
  {
    icon: <IconBathroom />,
    title: 'Salles de bain clé en main',
    desc: 'Conception et réalisation complète de salles de bain sur-mesure : carrelage, douche à l\'italienne, baignoire balnéo, robinetterie haut de gamme. De A à Z, sans stress.',
    featured: false,
  },
  {
    icon: <IconHeatPump />,
    title: 'Pompes à chaleur',
    desc: 'Spécialiste certifié RGE de l\'installation de pompes à chaleur air/eau et air/air. Réduisez vos factures jusqu\'à 75 % et bénéficiez des aides MaPrimeRénov\' et CEE.',
    featured: true,
    rge: true,
  },
];

const Services = () => (
  <section className="section section-alt" id="services">
    <div className="section-inner">
      <div className="section-header">
        <div className="section-tag">Nos domaines d'expertise</div>
        <h2 className="section-title">Des solutions complètes pour votre habitat</h2>
        <p className="section-subtitle">
          De la plomberie courante aux installations d'énergies renouvelables,
          nous couvrons tous vos besoins avec le même niveau d'exigence.
        </p>
      </div>

      <div className="services-grid">
        {SERVICES.map(({ icon, title, desc, featured, rge }) => (
          <div key={title} className={`service-card${featured ? ' featured' : ''}`}>
            <div className="service-icon">{icon}</div>
            <h3>{title}</h3>
            <p>{desc}</p>
            {rge && <div className="service-rge">Certifié RGE</div>}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
